/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  DashboardOnboardingControllerDetails401,
  DashboardOnboardingControllerDetails429,
  DashboardOnboardingControllerSkipAll401,
  DashboardOnboardingControllerSkipAll429,
  DashboardOnboardingControllerUpdateStep400,
  DashboardOnboardingControllerUpdateStep401,
  DashboardOnboardingControllerUpdateStep404,
  DashboardOnboardingControllerUpdateStep429,
  DashboardOnboardingStep,
  DashboardOnboardingUpdate,
} from ".././schemas";
import { restClient } from "../../restClient";
import type { ErrorType, BodyType } from "../../restClient";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * The five high-level onboarding milestones for the authenticated caller, each flagged completed or not (with the completion timestamp). Completion is sticky and row-based — auto-marked as the caller builds their organization out, or set manually.
 * @summary Get onboarding details (dashboard)
 */
export const dashboardOnboardingControllerDetails = (
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardOnboardingStep[]>(
    { url: `/api/dashboard/v1/onboarding`, method: "GET", signal },
    options
  );
};

export const getDashboardOnboardingControllerDetailsQueryKey = () => {
  return [`/api/dashboard/v1/onboarding`] as const;
};

export const getDashboardOnboardingControllerDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>,
  TError = ErrorType<
    DashboardOnboardingControllerDetails401 | DashboardOnboardingControllerDetails429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>, TError, TData>
  >;
  request?: SecondParameter<typeof restClient>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardOnboardingControllerDetailsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>
  > = ({ signal }) => dashboardOnboardingControllerDetails(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardOnboardingControllerDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>
>;
export type DashboardOnboardingControllerDetailsQueryError = ErrorType<
  DashboardOnboardingControllerDetails401 | DashboardOnboardingControllerDetails429
>;

export function useDashboardOnboardingControllerDetails<
  TData = Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>,
  TError = ErrorType<
    DashboardOnboardingControllerDetails401 | DashboardOnboardingControllerDetails429
  >,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardOnboardingControllerDetails<
  TData = Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>,
  TError = ErrorType<
    DashboardOnboardingControllerDetails401 | DashboardOnboardingControllerDetails429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboardOnboardingControllerDetails<
  TData = Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>,
  TError = ErrorType<
    DashboardOnboardingControllerDetails401 | DashboardOnboardingControllerDetails429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>, TError, TData>
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get onboarding details (dashboard)
 */

export function useDashboardOnboardingControllerDetails<
  TData = Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>,
  TError = ErrorType<
    DashboardOnboardingControllerDetails401 | DashboardOnboardingControllerDetails429
  >,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof dashboardOnboardingControllerDetails>>, TError, TData>
  >;
  request?: SecondParameter<typeof restClient>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardOnboardingControllerDetailsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Mark a single onboarding `step` complete (`isCompleted: true`, idempotent) or re-open it (`false`) for the authenticated caller. Onboarding is user-scoped — a caller can only ever touch their own steps. Returns the full step list in canonical guide order so the FE can swap its state without a re-fetch. 404 when the step is unknown.
 * @summary Toggle an onboarding step (dashboard)
 */
export const dashboardOnboardingControllerUpdateStep = (
  step: string,
  dashboardOnboardingUpdate: BodyType<DashboardOnboardingUpdate>,
  options?: SecondParameter<typeof restClient>
) => {
  return restClient<DashboardOnboardingStep[]>(
    {
      url: `/api/dashboard/v1/onboarding/${step}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: dashboardOnboardingUpdate,
    },
    options
  );
};

export const getDashboardOnboardingControllerUpdateStepMutationOptions = <
  TError = ErrorType<
    | DashboardOnboardingControllerUpdateStep400
    | DashboardOnboardingControllerUpdateStep401
    | DashboardOnboardingControllerUpdateStep404
    | DashboardOnboardingControllerUpdateStep429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardOnboardingControllerUpdateStep>>,
    TError,
    { step: string; data: BodyType<DashboardOnboardingUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardOnboardingControllerUpdateStep>>,
  TError,
  { step: string; data: BodyType<DashboardOnboardingUpdate> },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardOnboardingControllerUpdateStep>>,
    { step: string; data: BodyType<DashboardOnboardingUpdate> }
  > = (props) => {
    const { step, data } = props ?? {};

    return dashboardOnboardingControllerUpdateStep(step, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardOnboardingControllerUpdateStepMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardOnboardingControllerUpdateStep>>
>;
export type DashboardOnboardingControllerUpdateStepMutationBody =
  BodyType<DashboardOnboardingUpdate>;
export type DashboardOnboardingControllerUpdateStepMutationError = ErrorType<
  | DashboardOnboardingControllerUpdateStep400
  | DashboardOnboardingControllerUpdateStep401
  | DashboardOnboardingControllerUpdateStep404
  | DashboardOnboardingControllerUpdateStep429
>;

/**
 * @summary Toggle an onboarding step (dashboard)
 */
export const useDashboardOnboardingControllerUpdateStep = <
  TError = ErrorType<
    | DashboardOnboardingControllerUpdateStep400
    | DashboardOnboardingControllerUpdateStep401
    | DashboardOnboardingControllerUpdateStep404
    | DashboardOnboardingControllerUpdateStep429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardOnboardingControllerUpdateStep>>,
    TError,
    { step: string; data: BodyType<DashboardOnboardingUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardOnboardingControllerUpdateStep>>,
  TError,
  { step: string; data: BodyType<DashboardOnboardingUpdate> },
  TContext
> => {
  const mutationOptions = getDashboardOnboardingControllerUpdateStepMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Mark every onboarding step complete in one call for the authenticated caller — the "Skip all" action. Idempotent: steps already done keep their original completion. Returns the full step list in canonical guide order.
 * @summary Skip all onboarding steps (dashboard)
 */
export const dashboardOnboardingControllerSkipAll = (
  options?: SecondParameter<typeof restClient>,
  signal?: AbortSignal
) => {
  return restClient<DashboardOnboardingStep[]>(
    { url: `/api/dashboard/v1/onboarding/skip-all`, method: "POST", signal },
    options
  );
};

export const getDashboardOnboardingControllerSkipAllMutationOptions = <
  TError = ErrorType<
    DashboardOnboardingControllerSkipAll401 | DashboardOnboardingControllerSkipAll429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardOnboardingControllerSkipAll>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dashboardOnboardingControllerSkipAll>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dashboardOnboardingControllerSkipAll>>,
    void
  > = () => {
    return dashboardOnboardingControllerSkipAll(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DashboardOnboardingControllerSkipAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof dashboardOnboardingControllerSkipAll>>
>;

export type DashboardOnboardingControllerSkipAllMutationError = ErrorType<
  DashboardOnboardingControllerSkipAll401 | DashboardOnboardingControllerSkipAll429
>;

/**
 * @summary Skip all onboarding steps (dashboard)
 */
export const useDashboardOnboardingControllerSkipAll = <
  TError = ErrorType<
    DashboardOnboardingControllerSkipAll401 | DashboardOnboardingControllerSkipAll429
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dashboardOnboardingControllerSkipAll>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof restClient>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dashboardOnboardingControllerSkipAll>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getDashboardOnboardingControllerSkipAllMutationOptions(options);

  return useMutation(mutationOptions);
};
